import { Stack } from '@mui/material';

export default function Participants({ children, sx }) {
  return (
    <Stack direction="column" spacing={1} sx={{ ...sx }}>
      {children}
    </Stack>
  );
}
